import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/reset.css'
import VueCompositionAPI from '@vue/composition-api'
import { amountInWords,relativeDateFilter  } from './filters';

import Amount from './components/Amount.vue';
import Annotation from './components/Annotation.vue';
import ConversionTime from './components/ConversionTime.vue';
import DetailHeader from './components/DetailHeader.vue';

// 权限控制
import './utils/authority-control'
// 查询参数存储
import './utils/params-control'
import 'nprogress/nprogress.css'
Vue.use(ElementUI);
Vue.use(VueCompositionAPI)
Vue.config.productionTip = false
// 工具
import stringUtils from '@/utils/string-utils'
Vue.prototype.$stringUtils = stringUtils
import numberUtils from '@/utils/number-utils'
Vue.prototype.$numberUtils = numberUtils
Number.prototype.mul = function (arg) {
  return numberUtils.multiply(arg, this);
}
Vue.prototype.$platform = process.env.VUE_APP_PLATFORM

// 组件
Vue.component('Annotation',Annotation) //名词注解
Vue.component('DetailHeader',DetailHeader) // 流程页新头部
Vue.component('Amount',Amount) // 数字转大写
Vue.component('ConversionTime',ConversionTime) //时间换算

// 过滤器
Vue.filter('thousandBitSeparator', function (value) {
  return stringUtils.thousandBitSeparator(value)
})
Vue.filter('amountInWords', amountInWords);
Vue.filter('relativeDateFilter', relativeDateFilter);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
